import { render } from "./DataListSettings.vue?vue&type=template&id=36f8aa2c&scoped=true"
import script from "./DataListSettings.vue?vue&type=script&lang=js"
export * from "./DataListSettings.vue?vue&type=script&lang=js"

import "./DataListSettings.vue?vue&type=style&index=0&id=36f8aa2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f8aa2c"]])

export default __exports__